// Free-trial presets for the Ontario Provincial Report Card (pvrc1to6_2023_09).
// Each preset is a complete flat object matching every key in formSchema.
// Grade values: "A" | "B+" | "B" | "C+" | "C" | "D+" | "D" | "R" | "IE" | ""
// Plan values: "ESLELD" | "IEP" | "NA" | "Core" | "Immersion" | "Extended" | "French" | ""
// Learning skill values: "E" | "G" | "S" | "N" | ""
// ERS values: "Yes" | "No" | "NA" | ""

export const PRESETS = [
  {
    label: "Example: Mei Chen",
    data: {
      date: "2024-11-15",
      studentName: "Mei Chen",
      oen: "222333444",
      grade: "4",
      gradeInSeptember: "4",
      teacher: "Ms. Rivera",
      board: "Toronto District School Board",
      school: "Maple Leaf Public School",
      address1: "100 Main Street",
      address2: "Toronto, ON M4B 1A1",
      principal: "Mr. Johnson",
      telephone: "416-555-0100",
      daysAbsent: "2",
      totalDaysAbsent: "3",
      timesLate: "0",
      totalTimesLate: "0",
      responsibility1: "G",
      organization1: "E",
      independentWork1: "G",
      collaboration1: "G",
      initiative1: "G",
      selfRegulation1: "G",
      responsibility2: "G",
      organization2: "G",
      independentWork2: "G",
      collaboration2: "E",
      initiative2: "G",
      selfRegulation2: "G",
      strengthsNextStepsLSWH:
        "Mei demonstrates strong organizational skills and collaborates well with classmates. Next steps: continue to develop confidence in group discussions.",
      languagePlan: "",
      languageGrade1: "B",
      languageGrade2: "B+",
      languageComments:
        "Mei is making consistent progress in reading comprehension and written expression.",
      nativeLanguage: "",
      nativeLanguagePlan: "",
      nativeLanguageGrade1: "",
      nativeLanguageGrade2: "",
      nativeLanguageComments: "",
      frenchPlan: "Core",
      frenchListeningPlan: "",
      frenchListeningGrade1: "B",
      frenchListeningGrade2: "B",
      frenchSpeakingPlan: "",
      frenchSpeakingGrade1: "B",
      frenchSpeakingGrade2: "B+",
      frenchReadingPlan: "",
      frenchReadingGrade1: "B",
      frenchReadingGrade2: "B",
      frenchWritingPlan: "",
      frenchWritingGrade1: "B",
      frenchWritingGrade2: "B",
      frenchComments:
        "Mei participates actively in French and is developing her oral communication skills.",
      mathematicsPlan: "",
      mathematicsGrade1: "B+",
      mathematicsGrade2: "A",
      mathematicsComments: "Mei shows strong number sense and excellent problem-solving skills.",
      scienceAndTechnologyPlan: "",
      scienceAndTechnologyGrade1: "B",
      scienceAndTechnologyGrade2: "B+",
      scienceAndTechnologyComments: "",
      socialStudiesPlan: "",
      socialStudiesGrade1: "B",
      socialStudiesGrade2: "B",
      socialStudiesComments: "",
      healthEducationPlan: "",
      healthEducationGrade1: "B",
      healthEducationGrade2: "B",
      physicalEducationPlan: "",
      physicalEducationGrade1: "B+",
      physicalEducationGrade2: "B+",
      healthAndPhysicalEducationComments: "",
      artsHeader: "The Arts",
      arts1: "Visual Arts",
      arts1Plan: "",
      arts1Grade1: "B",
      arts1Grade2: "B+",
      arts2: "Music",
      arts2Plan: "",
      arts2Grade1: "B",
      arts2Grade2: "B",
      arts3: "Drama",
      arts3Plan: "",
      arts3Grade1: "B",
      arts3Grade2: "B",
      arts4: "",
      arts4Plan: "",
      arts4Grade1: "",
      arts4Grade2: "",
      artsComments: "",
      optionalStudies: "",
      optionalStudiesPlan: "",
      optionalStudiesGrade1: "",
      optionalStudiesGrade2: "",
      optionalStudiesComments: "",
      ersCompleted: "No",
      ersDateYear: "",
      ersDateMonth: "",
      ersDateDay: "",
      ersBenchmark: "NA",
    },
  },
  {
    label: "Example: Luca Rossi",
    data: {
      date: "2024-11-15",
      studentName: "Luca Rossi",
      oen: "555666777",
      grade: "7",
      gradeInSeptember: "7",
      teacher: "Mr. Williams",
      board: "Toronto District School Board",
      school: "Maple Leaf Public School",
      address1: "100 Main Street",
      address2: "Toronto, ON M4B 1A1",
      principal: "Mr. Johnson",
      telephone: "416-555-0100",
      daysAbsent: "5",
      totalDaysAbsent: "8",
      timesLate: "2",
      totalTimesLate: "3",
      responsibility1: "G",
      organization1: "S",
      independentWork1: "G",
      collaboration1: "G",
      initiative1: "G",
      selfRegulation1: "S",
      responsibility2: "G",
      organization2: "G",
      independentWork2: "G",
      collaboration2: "G",
      initiative2: "G",
      selfRegulation2: "G",
      strengthsNextStepsLSWH:
        "Luca is an engaged learner who contributes thoughtfully to class discussions. Next steps: develop more consistent organizational habits for long-term assignments.",
      languagePlan: "IEP",
      languageGrade1: "C+",
      languageGrade2: "B",
      languageComments:
        "Luca is making meaningful progress with the support of his IEP accommodations.",
      nativeLanguage: "",
      nativeLanguagePlan: "",
      nativeLanguageGrade1: "",
      nativeLanguageGrade2: "",
      nativeLanguageComments: "",
      frenchPlan: "Core",
      frenchListeningPlan: "",
      frenchListeningGrade1: "B",
      frenchListeningGrade2: "B",
      frenchSpeakingPlan: "",
      frenchSpeakingGrade1: "B",
      frenchSpeakingGrade2: "B",
      frenchReadingPlan: "",
      frenchReadingGrade1: "C+",
      frenchReadingGrade2: "B",
      frenchWritingPlan: "",
      frenchWritingGrade1: "C+",
      frenchWritingGrade2: "B",
      frenchComments: "",
      mathematicsPlan: "",
      mathematicsGrade1: "A",
      mathematicsGrade2: "A",
      mathematicsComments:
        "Luca excels in mathematics, demonstrating strong analytical thinking and problem-solving.",
      scienceAndTechnologyPlan: "",
      scienceAndTechnologyGrade1: "B+",
      scienceAndTechnologyGrade2: "A",
      scienceAndTechnologyComments: "",
      socialStudiesPlan: "",
      socialStudiesGrade1: "B",
      socialStudiesGrade2: "B+",
      socialStudiesComments: "",
      healthEducationPlan: "",
      healthEducationGrade1: "B",
      healthEducationGrade2: "B",
      physicalEducationPlan: "",
      physicalEducationGrade1: "B+",
      physicalEducationGrade2: "B+",
      healthAndPhysicalEducationComments: "",
      artsHeader: "The Arts",
      arts1: "Visual Arts",
      arts1Plan: "",
      arts1Grade1: "B",
      arts1Grade2: "B",
      arts2: "Music",
      arts2Plan: "",
      arts2Grade1: "C+",
      arts2Grade2: "B",
      arts3: "",
      arts3Plan: "",
      arts3Grade1: "",
      arts3Grade2: "",
      arts4: "",
      arts4Plan: "",
      arts4Grade1: "",
      arts4Grade2: "",
      artsComments: "",
      optionalStudies: "",
      optionalStudiesPlan: "",
      optionalStudiesGrade1: "",
      optionalStudiesGrade2: "",
      optionalStudiesComments: "",
      ersCompleted: "No",
      ersDateYear: "",
      ersDateMonth: "",
      ersDateDay: "",
      ersBenchmark: "NA",
    },
  },
  {
    label: "Example: Priya Patel",
    data: {
      date: "2024-11-15",
      studentName: "Priya Patel",
      oen: "888999000",
      grade: "2",
      gradeInSeptember: "2",
      teacher: "Ms. Kim",
      board: "Toronto District School Board",
      school: "Maple Leaf Public School",
      address1: "100 Main Street",
      address2: "Toronto, ON M4B 1A1",
      principal: "Mr. Johnson",
      telephone: "416-555-0100",
      daysAbsent: "1",
      totalDaysAbsent: "1",
      timesLate: "0",
      totalTimesLate: "0",
      responsibility1: "G",
      organization1: "G",
      independentWork1: "G",
      collaboration1: "G",
      initiative1: "G",
      selfRegulation1: "G",
      responsibility2: "G",
      organization2: "G",
      independentWork2: "G",
      collaboration2: "G",
      initiative2: "G",
      selfRegulation2: "G",
      strengthsNextStepsLSWH:
        "Priya is a dedicated student who consistently demonstrates positive learning skills. Next steps: encourage Priya to take more initiative in asking questions.",
      languagePlan: "",
      languageGrade1: "B",
      languageGrade2: "B",
      languageComments: "Priya is developing strong reading and writing skills.",
      nativeLanguage: "",
      nativeLanguagePlan: "",
      nativeLanguageGrade1: "",
      nativeLanguageGrade2: "",
      nativeLanguageComments: "",
      frenchPlan: "Core",
      frenchListeningPlan: "",
      frenchListeningGrade1: "B",
      frenchListeningGrade2: "B",
      frenchSpeakingPlan: "",
      frenchSpeakingGrade1: "B",
      frenchSpeakingGrade2: "B",
      frenchReadingPlan: "",
      frenchReadingGrade1: "B",
      frenchReadingGrade2: "B",
      frenchWritingPlan: "",
      frenchWritingGrade1: "B",
      frenchWritingGrade2: "B",
      frenchComments: "",
      mathematicsPlan: "",
      mathematicsGrade1: "B",
      mathematicsGrade2: "B",
      mathematicsComments: "",
      scienceAndTechnologyPlan: "",
      scienceAndTechnologyGrade1: "B",
      scienceAndTechnologyGrade2: "B",
      scienceAndTechnologyComments: "",
      socialStudiesPlan: "",
      socialStudiesGrade1: "B",
      socialStudiesGrade2: "B",
      socialStudiesComments: "",
      healthEducationPlan: "",
      healthEducationGrade1: "B",
      healthEducationGrade2: "B",
      physicalEducationPlan: "",
      physicalEducationGrade1: "B",
      physicalEducationGrade2: "B",
      healthAndPhysicalEducationComments: "",
      artsHeader: "The Arts",
      arts1: "Visual Arts",
      arts1Plan: "",
      arts1Grade1: "B",
      arts1Grade2: "B",
      arts2: "Music",
      arts2Plan: "",
      arts2Grade1: "B",
      arts2Grade2: "B",
      arts3: "",
      arts3Plan: "",
      arts3Grade1: "",
      arts3Grade2: "",
      arts4: "",
      arts4Plan: "",
      arts4Grade1: "",
      arts4Grade2: "",
      artsComments: "",
      optionalStudies: "",
      optionalStudiesPlan: "",
      optionalStudiesGrade1: "",
      optionalStudiesGrade2: "",
      optionalStudiesComments: "",
      ersCompleted: "No",
      ersDateYear: "",
      ersDateMonth: "",
      ersDateDay: "",
      ersBenchmark: "NA",
    },
  },
];
